import React, { ReactNode } from 'react';
import css from './index.module.scss';
import csx from 'classnames';

export interface InfoHeaderProps {
  title: ReactNode;
  subtitle?: string;
  description?: ReactNode;
  className?: string;
}

export const InfoHeader = (props: InfoHeaderProps) => {
  return (
    <div className={csx(css.container, props.className)}>
      {props.subtitle && (
        <p className={css.subtitle}>{props.subtitle}</p>
      )}
      <h3 className={css.title}>{props.title}</h3>
      {props.description && (
        <p className={css.description}>{props.description}</p>
      )}
    </div>
  );
};
